import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Box,
  InputAdornment,
  TextField,
  Button,
  List,
  ListItemButton,
  ListItemText,
  CircularProgress,
  Tooltip,
} from "@mui/material";
import FrameIcon from "../../../src/assests/images/frameIcon.svg";
import ExtendsDate from "./ExtendsDate";
import FilterTags from "../AssignTask/FilterTags";
import CalendarCircle from "../../../src/assests/images/calendar-circle.svg";
import CalendarGreen from "../../../src/assests/images/calendar-green.svg";
import CalendarRed from "../../../src/assests/images/calendar-red.svg";
import Edit from "../../../src/assests/images/edit-2.svg";
import { number } from "yup";
import PaginationComponent from "../AssignTask/Pagination";
import { useNavigate } from "react-router-dom";
import Dublicate from "../../../src/assests/images/dublicate-icon.svg";
import { Link } from "react-router-dom"; // Using react-router-dom for navigation
import { ispubishedchnages } from "./api";
import { getToken } from "../../utils/utils";
import SearchIcon from "@mui/icons-material/Search";
import sorterArrow from "../../../src/assests/images/SortingArrow.svg";

interface CohortCardProps {
  cohort: any;
  value: number;
}

const CohortCard: React.FC<CohortCardProps> = ({ cohort, value }) => {
  const [open, setOpen] = useState(false);
  const [cohorttitel, setcohorttitel] = useState("");
  const [cohortid, setcohortid] = useState("");
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [totalPages1, setTotalPages] = useState(0);
  const [Totalcount, setTotalcount] = useState(0);
  const [taskid, settaskid] = useState("");
  const token = getToken();
  const [cohortassigneddate, setcohortassigneddate] = useState("");
  const [cohortendDate, setcohortendDate] = useState("");
  const [cohortendDate22, setcohortendDate22] = useState("");

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  console.log(cohort, "cohortsssss44444444");

  const handleLinkClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // ✅ prevents parent onClick (like a card) from firing
    setTimeout(() => {
      window.location.reload(); // ✅ reloads after 100ms
    }, 100);
  };
  const handleDuplicateClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent card click navigation
    navigate(`/manage-task/duplicate-task/${cohort.task_id}`); // Navigate to the duplicate task page
    // Optionally call onDuplicate if needed
    // onDuplicate(cohort);
  };

  console.log(cohort, "mmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmm");
  console.log(cohortendDate, "openopenopenopenopenopenopenopen");
  console.log(cohort.task_id, "cohort.task_idcohort.task_id");

  return (
    <>
     
        <Card
          sx={{
            maxWidth: "30%",
            minWidth: "30%",
            margin: 2,
            border: "1px solid rgba(0, 0, 0, 0.12)",
            boxShadow: "none",
            borderRadius: "10px",
            "&:hover": {
              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)", // Add hover shadow effect
              // Optional: slightly enlarge the card on hover
            },
            transition: "box-shadow 0.3s ease, transform 0.3s ease",
          }}
        >
          <CardContent
            onClick={() =>
              navigate(`/active-task/assign-task/${cohort.task_id}/active_task`)
            }
          >
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              sx={{
                borderBottom: "1px dashed #d0d0d0 !important",
                marginBottom: "10px",
                paddingBottom: "10px",
              }}
            >
              <Box>
                <Typography
                  sx={{ color: "#696A6B", fontSize: "14px", display: "flex" }}
                >
                  <img src={FrameIcon} alt="FrameIcon" />
                  {/* <Typography sx={{ margin: "0px 10px" }}>
                    {cohort.taskTitle}
                    <Typography
                      sx={{ fontSize: "18px", color: "#282829" }}
                      variant="h6"
                      fontWeight="bold"
                    >
                      {cohort.title}
                    </Typography>
                  </Typography> */}
                  <Typography sx={{ margin: "0px 10px" }}>
  {cohort.taskTitle}
  <Tooltip title={cohort.title} arrow>
    <Typography
      sx={{
        fontSize: "18px",
        color: "#282829",
        fontWeight: "bold",
        display: "block",
        maxWidth: 150, // limit width
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        verticalAlign: "bottom",
      }}
      variant="h6"
    >
      {cohort.title}
    </Typography>
  </Tooltip>
</Typography>
                </Typography>
              </Box>
              <Box>
                <Typography
                  sx={{
                    fontSize: "12px",
                    color:
                      cohort.tag === "Not Published" ? "#696A6B" : "#2E844A", // Default green for anything above 1d left
                    background:
                      cohort.tag === "Not Published" ? "#E3E3E3" : "#EBF7E6", // Default light green for anything above 1d left
                    padding: "7px 10px",
                    borderRadius: "10px",
                    fontWeight: "600",
                  }}
                >
                  {cohort.tag}
                </Typography>
              </Box>

              <Box>
                <img
                  src={Dublicate}
                  alt="Duplicate Icon"
                  style={{ cursor: "pointer", width: "23px" }}
                  onClick={handleDuplicateClick} // Use the navigation handler
                />
              </Box>
            </Box>

            <Typography
              variant="body2"
              sx={{ color: "#696A6B", fontSize: "14px", marginBottom: "8px" }}
            >
              Credit Points: <b style={{ color: "#282829" }}>{cohort.points}</b>
            </Typography>
            <Typography
              variant="body1"
              sx={{ color: "#696A6B", fontSize: "14px", marginBottom: "8px" }}
            >
              Created By: <b style={{ color: "#282829" }}>{"Admin"}</b>
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: "#696A6B", fontSize: "14px", marginBottom: "8px" }}
            >
              Created At:{" "}
              <b style={{ color: "#282829" }}>{cohort.created_at}</b>
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: "#696A6B", fontSize: "14px", marginBottom: "8px" }}
            >
              Task Status:
              <b style={{ color: "#282829" }}>
                {value === 1 ? "Active" : "Scheduled"}
              </b>
            </Typography>
            <Typography
              variant="body1"
              sx={{ color: "#696A6B", fontSize: "14px", marginBottom: "8px" }}
            >
              Total Users:{" "}
              <b style={{ color: "#282829" }}>{cohort.totalUsers}</b>
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: "#696A6B", fontSize: "14px", marginBottom: "8px" }}
            >
              Assigned Date:{" "}
              <b style={{ color: "#282829" }}>{cohort.assignedDate}</b>
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: "#696A6B", fontSize: "14px", marginBottom: "8px" }}
            >
              End Date: <b style={{ color: "#282829" }}>{cohort.endDate}</b>
            </Typography>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "16px",
                marginTop: "16px",
                
              }}
            >
              {/* <Link
                to={`/Admin_approval/${cohort.task_id}/Educational`}
                //  target="_blank"
                rel="noopener noreferrer"
                style={{
                  border: "1px solid rgba(200, 23, 47, 1)",
                  borderRadius: "8px",
                  padding: "6px 40px", // Reduced vertical padding to 6px, increased horizontal to 40px for wider buttons
                  color: "rgba(200, 23, 47, 1)",
                  textDecoration: "none",
                  textAlign: "center",
                  fontSize: "14px",
                  fontWeight: "500",
                  boxSizing: "border-box",
                  lineHeight: "1.2", // Tighter vertical alignment for shorter height
                  flex: 1, // Use flex to grow equally and handle alignment dynamically
                }}
                onClick={handleLinkClick}
              >
                Preview Task
              </Link> */}
               <Link
                                    to={`/Admin_approval/${cohort.task_id}/Educational`}
                                    // target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                      border: "1px solid rgba(200, 23, 47, 1)",
                                      borderRadius: "8px",
                                      padding: "6px 40px", // Reduced vertical padding to 6px, increased horizontal to 40px for wider buttons
                                      color: "rgba(200, 23, 47, 1)",
                                      textDecoration: "none",
                                      textAlign: "center",
                                      fontSize: "14px",
                                      fontWeight: "500",
                                      boxSizing: "border-box",
                                      lineHeight: "1.2", // Tighter vertical alignment for shorter height
                                      flex: 1, // Use flex to grow equally and handle alignment dynamically
                                      whiteSpace: "nowrap",
                                    }}
                                    onClick={handleLinkClick}
                                  >
                                    Preview Task
                                  </Link>
                                  <Link
                                    to={`/manage-task/edit-task/${cohort.task_id}`}
                                    // target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                      border: "1px solid rgba(200, 23, 47, 1)",
                                      borderRadius: "8px",
                                      padding: "6px 40px", // Reduced vertical padding to 6px, increased horizontal to 40px for wider buttons
                                      color: "#FFF",
                                      textDecoration: "none",
                                      background: "rgba(200, 23, 47, 1)",
                                      textAlign: "center",
                                      fontSize: "14px",
                                      fontWeight: "500",
                                      boxSizing: "border-box",
                                      lineHeight: "1.2", // Tighter vertical alignment for shorter height
                                      flex: 1, // Use flex to grow equally and handle alignment dynamically
                                    }}
                                    onClick={handleLinkClick}
                                  >
                                    Edit Task
                                  </Link>
            </Box>
            {/* <FilterTags title="Applied Filters :" appliedFilters={cohort.applied_filters} /> */}
          </CardContent>
        </Card>
    

      <ExtendsDate
        open={open}
        onClose={handleClose}
        cohorttitel={cohorttitel}
        cohortassigneddate={cohortassigneddate}
        cohortendDate22={cohortendDate22}
        cohortendDate={cohortendDate}
        taskid={taskid}
      />
    </>
  );
};

// const ActiveTask = ({ title }: any) => {
//   const [cohorts] = useState(initialCohorts);
const ActiveTask = ({
  activeTaskData,
  title,
  searchTermtasks,
  setSearchTermactivetasks,
  searchTermschduled,
  setSearchTermschduled,
  debouncedSearchactivetasks,
  setDebouncedSearchactivetasks,
  debouncedSearchsheduled,
  setDebouncedSearchschduled,
  value,
  sortOptionactivetask,
  setSortOptionactivetask,
  loading,
}: {
  activeTaskData: any[];
  title: any;
  value: number;
  searchTermtasks: string;
  setSearchTermactivetasks: React.Dispatch<React.SetStateAction<string>>;
  searchTermschduled: string;
  setSearchTermschduled: React.Dispatch<React.SetStateAction<string>>;
  debouncedSearchactivetasks: string;
  setDebouncedSearchactivetasks: React.Dispatch<React.SetStateAction<string>>;
  debouncedSearchsheduled: string;
  setDebouncedSearchschduled: React.Dispatch<React.SetStateAction<string>>;
  sortOptionactivetask: "highest" | "lowest" | null;
  setSortOptionactivetask: React.Dispatch<
    React.SetStateAction<"highest" | "lowest" | null>
  >;
  loading: boolean;
}) => {
  const sortButtonRef = useRef<HTMLButtonElement>(null);
  const popupRef = useRef<HTMLDivElement>(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  // Handle sort popup open/close
  const handleSortButtonClick = () => setIsPopupOpen((prev) => !prev);

  // Handle selection of sort option
  const handleSortSelection = (option: "highest" | "lowest") => {
    setSortOptionactivetask(option);
    setIsPopupOpen(false);
  };

  const currentSearchTerm = value === 1 ? searchTermtasks : searchTermschduled;
  const setCurrentSearchTerm =
    value === 1 ? setSearchTermactivetasks : setSearchTermschduled;

  // Sort the data based on sortOptionactivetask
  const sortedData = useMemo(() => {
    if (!sortOptionactivetask) return activeTaskData;

    return [...activeTaskData].sort((a, b) => {
      const pointsA = Number(a.points) || 0;
      const pointsB = Number(b.points) || 0;
      return sortOptionactivetask === "highest"
        ? pointsB - pointsA
        : pointsA - pointsB;
    });
  }, [activeTaskData, sortOptionactivetask]);

  // Add useEffect for debouncing
  useEffect(() => {
    const handler = setTimeout(() => {
      if (value === 1) {
        setDebouncedSearchactivetasks(currentSearchTerm);
      } else {
        setDebouncedSearchschduled(currentSearchTerm);
      }
    }, 500);
    return () => clearTimeout(handler);
  }, [
    currentSearchTerm,
    value,
    setDebouncedSearchactivetasks,
    setDebouncedSearchschduled,
  ]);

  return (
    <>
      {/* <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{ fontSize: "16px", fontWeight: "600", marginBottom: "20px" }}
        >
          {title}
        </Typography>
      </Box> */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "24px",
          padding: "0 30px",
          marginBottom: "26px",
        }}
      >
        <Box>
          <TextField
            required
            placeholder={"Search by Task Name, Task Type"}
            sx={{
              ".MuiOutlinedInput-root": {
                borderRadius: "12px",
                height: "48px",
                width: "521px",
                "@media (max-width:1366px)": {
                  width: "400px",
                },
              },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            value={currentSearchTerm}
            onChange={(e) => setCurrentSearchTerm(e.target.value)}
          />
        </Box>

        <Box sx={{ position: "relative" }}>
          <Button
            ref={sortButtonRef}
            onClick={handleSortButtonClick}
            variant="outlined"
            sx={{
              height: "48px",
              borderRadius: "12px",
              minWidth: "200px",
              textTransform: "none",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            Sort By UpdateAt
            <img
              src={sorterArrow}
              alt="Sort Arrow"
              style={{ width: "16px", height: "16px" }}
            />
          </Button>

          {/* Sort Popup */}
          {isPopupOpen && (
            <Box
              ref={popupRef}
              sx={{
                position: "absolute",
                top: "55px",
                right: 0,
                backgroundColor: "#fff",
                border: "1px solid #ccc",
                borderRadius: "8px",
                zIndex: 999,
                width: "200px",
                boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
              }}
            >
              <List>
                <ListItemButton onClick={() => handleSortSelection("highest")}>
                  <ListItemText primary="⬇️ Highest to Lowest" />
                </ListItemButton>
                <ListItemButton onClick={() => handleSortSelection("lowest")}>
                  <ListItemText primary="⬆️ Lowest to Highest" />
                </ListItemButton>
              </List>
            </Box>
          )}
        </Box>
      </Box>
      <Grid
        container
        spacing={2}
        sx={{ margin: "0 10px", minHeight: "200px", position: "relative" }}
      >
        {loading ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "200px",
              width: "100%",
              position: "absolute",
              top: 0,
              left: 0,
              backgroundColor: "rgba(255, 255, 255, 0.8)",
              zIndex: 1,
            }}
          >
            <CircularProgress />
          </Box>
        ) : sortedData.length > 0 ? (
          sortedData.map((cohort, index) => (
            <CohortCard key={index} cohort={cohort} value={value} />
          ))
        ) : (
          <Typography sx={{ textAlign: "center", width: "100%" }}>
            No data available
          </Typography>
        )}
      </Grid>
    </>
  );
};

export default ActiveTask;
